import { render } from "./CreatePasswordModal2.vue?vue&type=template&id=8d5dae5c&scoped=true&ts=true"
import script from "./CreatePasswordModal2.vue?vue&type=script&lang=ts"
export * from "./CreatePasswordModal2.vue?vue&type=script&lang=ts"

import "./CreatePasswordModal2.vue?vue&type=style&index=0&id=8d5dae5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5dae5c"],['__file',"src/components/modals/start/CreatePasswordModal2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d5dae5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d5dae5c', __exports__)) {
    api.reload('8d5dae5c', __exports__)
  }
  
  module.hot.accept("./CreatePasswordModal2.vue?vue&type=template&id=8d5dae5c&scoped=true&ts=true", () => {
    api.rerender('8d5dae5c', render)
  })

}


export default __exports__